import servicesAuth from "../../services/auth";
import * as constant from "./constant";

export function setLoading(payload) {
  return { type: constant.LOADING, payload: payload };
}

export function setSigninResponse(payload) {
  return { type: constant.SIGNIN_RESPONSE, payload: payload };
}

export function setSignupResponse(payload) {
  return { type: constant.SIGNUP_RESPONSE, payload: payload };
}

export function setForgotResponse(payload) {
  return { type: constant.FORGOT_RESPONSE, payload: payload };
}

export function setRefreshResponse(payload) {
  return { type: constant.REFRESH_RESPONSE, payload: payload };
}

export function setResetResponse(payload) {
  return { type: constant.RESET_RESPONSE, payload: payload };
}

export function setResendResponse(payload) {
  return { type: constant.RESEND_RESPONSE, payload: payload };
}

export function authSignin(payload) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await servicesAuth.authSignin(payload);
      dispatch(setSigninResponse(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}

export function authSignup(payload) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await servicesAuth.authSignup(payload);
      dispatch(setSignupResponse(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}

export function authForgot(payload) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await servicesAuth.authForgot(payload);
      dispatch(setForgotResponse(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}

export function authRefresh() {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await servicesAuth.authRefresh();
      dispatch(setRefreshResponse(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}

export function authReset(payload) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await servicesAuth.authReset(payload);
      dispatch(setResetResponse(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}

export function authResendVerify(params) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await servicesAuth.authResendVerify(params);
      dispatch(setResendResponse(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}
